<template>
  <div class="icons-block">
    <el-tooltip effect="light" content="卡片信息" placement="top">
      <div
        class="icon-fir"
        @mouseover="changeSecondUrl(true)"
        @mouseleave="changeSecondUrl(false)"
        @click="handleShowInfo"
      >
        <img :src="iconSecondUrl" alt="" />
      </div>
    </el-tooltip>
    <el-tooltip effect="light" content="下载" placement="top">
      <div
        class="icons-sec"
        @mouseover="changeThirdUrl(true)"
        @mouseleave="changeThirdUrl(false)"
        @click="handleDownload"
      >
        <img :src="iconThirdUrl" alt="" />
      </div>
    </el-tooltip>
  </div>
</template>

<script>
export default {
  data() {
    return {
      iconSec: false,
      iconThr: false,
    };
  },
  computed: {
    iconSecondUrl() {
      return this.iconSec
        ? require("../../../assets/img/icons/lightabout.svg")
        : require("../../../assets/img/icons/blackabout.svg");
    },
    iconThirdUrl() {
      return this.iconThr
        ? require("../../../assets/img/icons/lightdownload.svg")
        : require("../../../assets/img/icons/blackDownload.svg");
    },
  },
  methods: {
    changeSecondUrl(show) {
      this.iconSec = show;
    },
    changeThirdUrl(show) {
      this.iconThr = show;
    },
    handleShowInfo() {
      this.$emit("handleShowInfo", true);
    },
    handleDownload() {
      this.$emit("handleDownload", true);
    },
  },
};
</script>

<style scoped>
.icons-block {
  display: flex;
  justify-content: space-between;
  border-radius: 4px;
  border: 1px solid #dddddd;
  padding: 8px 6px 6px 6px;
  cursor: pointer;
}
.icon-fir {
  margin-left: 6px;
}
.icons-sec {
  margin: 0 6px 0 12px;
}
</style>


// WEBPACK FOOTER //
// src/components/dataChart/iconsBlock/iconsblock.vue